<template>
	<validation-observer v-slot="{ passes, invalid }">
		<a-modal v-model:visible="opened" title="Añadir usuario" @ok="passes(handleOk)">
			<template #footer>
				<a-button key="back" @click="resetForm">
					Cancelar
				</a-button>
				<a-button key="submit" html-type="submit" type="primary" :loading="loading" :disabled="invalid" @click="passes(register)">
					Registrar
				</a-button>
			</template>
			<form @submit.prevent="passes(register)">
				<div class="row">
					<div class="col-12 col-sm-6">
						<validation-provider v-slot="slotProps" name="Usuario" rules="required|min:4|max:16">
							<a-form-item label="Usuario" required has-feedback :validate-status="validation().resolveState(slotProps)" :help="slotProps.errors[0]">
								<a-input v-model:value="params.username" :size="inputSize" placeholder="Usuario">
									<template #prefix>
										<a-icon type="user" />
									</template>
								</a-input>
							</a-form-item>
						</validation-provider>
					</div>
					<div class="col-12 col-sm-6">
						<validation-provider v-slot="slotProps" name="Email" rules="required|email">
							<a-form-item label="Email" required has-feedback :validate-status="validation().resolveState(slotProps)" :help="slotProps.errors[0]">
								<a-input v-model:value="params.email" :size="inputSize" placeholder="Email">
									<template #prefix>
										<a-icon type="mail" />
									</template>
								</a-input>
							</a-form-item>
						</validation-provider>
					</div>
				</div>
				<div class="row">
					<div class="col-12 col-sm-6">
						<validation-provider v-slot="slotProps" vid="newpassword" name="Contraseña" rules="required|min:6|max:50">
							<a-form-item label="Contraseña actual" required has-feedback :validate-status="validation().resolveState(slotProps)" :help="slotProps.errors[0]">
								<a-input v-model:value="params.password" :size="inputSize" type="password">
									<template #prefix>
										<a-icon type="lock" />
									</template>
								</a-input>
							</a-form-item>
						</validation-provider>
					</div>
					<div class="col-12 col-sm-6">
						<validation-provider v-slot="slotProps" name="Contraseña" rules="required|confirmed:newpassword">
							<a-form-item label="Repite la contraseña" required has-feedback :validate-status="validation().resolveState(slotProps)" :help="slotProps.errors[0]">
								<a-input v-model:value="params.password2" :size="inputSize" type="password">
									<template #prefix>
										<a-icon type="lock" />
									</template>
								</a-input>
							</a-form-item>
						</validation-provider>
					</div>
				</div>
			</form>
		</a-modal>
	</validation-observer>
</template>

<script>
export default {
	name: 'UserAdd',
	components: {},
	data() {
		return {
			opened: false,
			loading: false,
			params: {
				username: '',
				email: '',
				password: '',
				password2: '',
				newsletter: false,
			},
		};
	},
	computed: {
		inputSize() {
			return this.$store.getters.settings.inputSize;
		},
	},
	created() {
		const self = this;
		this.$hub.on('addUser', () => {
			self.opened = true;
		});
	},
	unmounted() {
		this.$hub.off('addUser');
	},
	methods: {
		async register() {
			this.loading = true;

			const params = {
				username: this.params.username,
				email: this.params.email,
				password: this.params.password,
				newsletter: false,
			};

			const register = await this.$sdk.users().add(params);

			if (register.ok) {
				this.resetForm();

				this.$router.push({ name: 'user', params: { id: register.user.id } });
				this.$message.success('Hemos enviado un email a la direccion de correo para activar la cuenta');
			} else {
				this.$message.error('No se ha podido crear el usuario');
			}

			this.loading = false;
		},
		resetForm() {
			this.params = {
				username: '',
				email: '',
				password: '',
				password2: '',
				newsletter: false,
			};

			this.opened = false;
		},
	},
};
</script>

<style lang="scss" module>

</style>
